import styled from "styled-components";
import { theme } from "../../theme";
import { lighten, rgba } from "polished";
export const HeaderLayout = styled("header")(({
  fullWidth,
}) => {
  return {
   
    height: "4.375rem",
    position: "fixed",
    top: 0,
    right: "1.25rem",
    width: fullWidth ? "calc(100% - 2.5rem)":"calc(100% - 21.25rem)",
    padding: "0.625rem 1.25rem",
    zIndex: 11,
    transition: "all .3s",
    boxShadow: `0px 0.125rem 0.9375rem ${rgba(theme.colors.dark.dark, 0.05)} `,
    /*borderInlineEnd:rgba(`${theme.colors.secondary.light}`, 0.25)+`solid 0.0625rem` ,*/ backgroundColor: `${theme.colors.light.light}`,
    borderRadius: `0 0 ${theme.radius.card} ${theme.radius.card}`,
    display: "flex",
    alignItems: "center",
    "&.sticky": {
      backgroundColor: rgba(`${theme.colors.light.light}`, 0.95),
      backdropFilter: "blur(0.375rem)",
    },
    "&.navCollapse": { width: "calc(100% - 7.5rem)" },

    "@media (max-width: 550px)": {},
  };
});


export const HeaderContainer = styled.div({
  justifyContent: "space-between",
  display: "flex",
  alignItems: "center",
  gap: "1.25rem",
  width: "100%",
});
export const NavStyle = styled.nav({
  display: "inline-flex",
  alignItems: "center",
  marginInlineStart: "2rem",
  "& ul": {
    display: "flex",
    alignItems: "center",
    listStyle: "none",
    padding: 0,
    margin: 0,
    gap: "1.875rem",
    "& a": {
      color: "#999",
      "&:hover": { color: "#000" },
      "&.active": { color: "#6c00ff" },
    },
  },
});

export const HeaderMenu = styled.div({
  backgroundColor: ({ theme }) => theme.colors.light.main,
  position: "absolute",
  right: "1.25rem",
  top: "100%",
  padding: "0.625rem ",
  borderRadius: "0rem 0rem 0.625rem 0.625rem",
  zIndex: "10",
  minWidth: "18.75rem",
  maxHeight: ({ isVisible }) => (isVisible ? "37.563rem" : "0rem"),
  overflow: "hidden",
  transition: "max-height 0.3s ease",
  visibility: ({ isVisible }) => (isVisible ? "visible" : "hidden"),
  opacity: ({ isVisible }) => (isVisible ? 1 : 0),
  transitionProperty: "max-height, opacity",
  boxShadow: `0px 0 1.25rem ${rgba(theme.colors.dark.dark, 0.15)}`,
  "button": {
    marginBlockStart: "1.5rem",
  },
});

export const HeaderUserList = styled.ol({
  backgroundColor: `${theme.colors.light.light}`,
  marginBlock: "0",
  listStyle: "none",
  padding: "0.625rem 0.5rem",
  borderRadius:"0.5rem",
  marginBlockEnd: "1rem",
  "&>li": {
    position: "relative",
    transition: "all .3s",
    display:"flex",
    alignItems:"center",
    gap:"0.75rem",
    padding:"0.625rem 0.938rem",
    borderRadius:"0.5rem",
    "&.active": {
      backgroundColor: lighten(0.35, theme.colors.secondary.main),
    },
    "&:hover":{
      backgroundColor: `${theme.colors.light.dark}`,
    }
  },
});
export const HeaderUserItem = styled.li({});
